export const labelStyle = "font-semibold px-2 py-1";
export const inputStyle = "border-b border-gray-300 w-24 px-2";

export const divStyle = "flex flex-row gap-3";

export const titleStyle = "text-2xl py-4";
export const subTitleStyle = "text-lg font-semibold py-2";